import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../components/Loader';
import { DeleteConfrimationModal } from '../../../components/admin/DeleteConfirmationModal';
import { AddManufacturerUserModal } from './addManufacturerUserModal';
import { loadManufacturerUsers, addManufacturerUser, editManufacturerUserAction, deleteManufacturerUserAction, getManufacturerUsersSelector } from '../../../store/manufacturer-reducer';


const newUser = {
    id: null,
    fullName: '',
    email: '',
    organization: '',
    password: '',
};

export default function EditManufacturerDetails() {

    const dispatch = useDispatch();
    const { manufacturerId } = useParams();

    const manufacturerUsers = useSelector(getManufacturerUsersSelector);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [manufacturerUserModel, setManufacturerUserModel] = useState(null);

    const [showAddModal, setShowAddModal] = useState(false);
    const [editUser, setEditUser] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (manufacturerId) {
            setLoading(true);

            dispatch(loadManufacturerUsers(manufacturerId))
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [dispatch, manufacturerId]);

    const handleDeleteTrigger = (userId, title) => {

        setManufacturerUserModel({ userId, manufacturerId, title });
        setShowDeleteModal(true);
    };

    const handleDeleteManufacturerUser = () => {

        if (manufacturerUserModel?.userId && manufacturerUserModel?.manufacturerId) {
            dispatch(deleteManufacturerUserAction({
                manufacturerId: manufacturerUserModel.manufacturerId,
                userId: manufacturerUserModel.userId
            }));
        }
        setShowDeleteModal(false);
    };

    const handleEditManufacturerUser = (id) => {

        const user = manufacturerUsers.find((u) => u.id === id);
        if (user) {
            setEditUser(user);
            setShowAddModal(true);
        }
    };

    const handleSaveManufacturerUser = (data, onSuccess, onError) => {
        const manufacturerData = {
            manufacturerId,
            user: data
        };

        if (editUser && editUser.id) {
            // Editing existing user
            dispatch(editManufacturerUserAction({ ...manufacturerData, user: { ...editUser, ...data } }));
        } else {
            // Adding new user
            dispatch(addManufacturerUser(manufacturerData, onSuccess, onError));
        }

        setEditUser(null);
        setShowAddModal(false);
    };


    return (
        <>
            <DeleteConfrimationModal
                show={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                handleDeleteEvent={handleDeleteManufacturerUser}
                model={manufacturerUserModel}
            />

            <AddManufacturerUserModal
                show={showAddModal}
                onClose={() => {
                    setShowAddModal(false);
                    setEditUser(null);
                }}
                handleAddManufacturer={handleSaveManufacturerUser}
                initialData={editUser || newUser}
            />

            <div className="admin-tab-content">
                <button
                    className="admin-button"
                    onClick={() => {
                        setEditUser(newUser);
                        setShowAddModal(true);
                    }}
                >
                    <span className="admin-button-text">Add Manufacturer User</span>
                    <span
                        className="admin-button-icon material-symbols-rounded"
                        aria-hidden="true"
                    >
                        add
                    </span>
                </button>
                {loading ? <Loader /> :
                    <div className="admin-table-wrap">
                        <table className="admin-table">
                            <thead>
                                <tr>
                                    <th>Full Name</th>
                                    <th>Email</th>
                                    <th>Organization</th>
                                    <th className="admin-table-action-cell">&nbsp;</th>
                                    <th className="admin-table-action-cell">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {manufacturerUsers && manufacturerUsers.length > 0 ? (
                                    manufacturerUsers.map((item) => (
                                        <tr key={'manufacturer_user_' + item.id}>
                                            <td>{item.fullName}</td>
                                            <td>{item.email}</td>
                                            <td>{item.organization}</td>
                                            <td className="table-action-cell">
                                                <button
                                                    className="admin-table-action"
                                                    title="edit"
                                                    data-id={item.id}
                                                    onClick={(e) =>
                                                        handleEditManufacturerUser(
                                                            e.currentTarget.dataset.id
                                                        )
                                                    }
                                                >
                                                    <span className="material-symbols-rounded">edit</span>
                                                </button>
                                            </td>
                                            <td className="table-action-cell">
                                                <button
                                                    className="admin-table-action"
                                                    title="delete"
                                                    data-id={item.id}
                                                    onClick={() =>
                                                        handleDeleteTrigger(item.id, item.fullName)
                                                    }
                                                >
                                                    <span className="material-symbols-rounded">delete</span>
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5">No data available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        </>
    );
} 